/**
 * Created by dimah on 02/07/17.
 */

import { AbstractDTO } from "./abstract";
import { IAcl } from "@signature-it/ngx-generic/interfaces";

export class AclDTO extends AbstractDTO implements IAcl {
    id: number;
    checked: boolean;
    description: string;
    excluded: boolean;
    excludedDescription: string;
    name: string;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.id = Number(attributes['id']) || 0;
        this.checked = String(attributes['checked']) === 'true';
        this.description = attributes['description'] || null;
        this.excluded = String(attributes['excluded']) === 'true';
        this.excludedDescription = attributes['excludedDescription'] || "";
        this.name = attributes['name'] || null;
    }

}
